import { useRouter } from "next/router";
import { useEffect, useState } from "react";

export default function usePagination({ itemsPerPage, totalItems }: { itemsPerPage: number; totalItems: number }) {
	const router = useRouter();
	const totalPages = Math.ceil(totalItems / itemsPerPage);
	const urlPage = Number(router.query.page);
	const [page, setPage] = useState(!Number.isNaN(urlPage) && urlPage <= totalPages ? urlPage : 1);

	useEffect(() => {
		if (urlPage !== page && !Number.isNaN(urlPage) && urlPage <= totalPages) {
			setPage(urlPage);
		}
	}, [urlPage, page, totalPages]);

	const nextPage = () => {
		setPage(Math.min(totalPages, page + 1));
	};

	const prevPage = () => {
		setPage(Math.max(1, page - 1));
	};

	return { nextPage, page, prevPage, totalPages };
}
